import React from "react";
import { Box } from "@mui/material";
import ProjectDocumentsManager from "../../projectDocuments/ProjectDocumentsManager";

/**
 * Gestão de documentos do projeto
 */
export default function DocumentsAccordion({ projectData }) {
  return (
    <Box sx={{ width: "100%" }}>
      <ProjectDocumentsManager
        projectId={projectData.id}
        projectNumber={projectData.projectNumber}
        projectData={projectData}
      />
    </Box>
  );
}

